import { render, staticRenderFns } from "./HKLText.vue?vue&type=template&id=7c585914&"
import script from "./HKLText.vue?vue&type=script&lang=js&"
export * from "./HKLText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c585914')) {
      api.createRecord('7c585914', component.options)
    } else {
      api.reload('7c585914', component.options)
    }
    module.hot.accept("./HKLText.vue?vue&type=template&id=7c585914&", function () {
      api.rerender('7c585914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/HKLText.vue"
export default component.exports